export class ExtratoAtlasConselhoDeliberativo {

    static extratoAtlasConselhoDeliberativoLista: ExtratoAtlasConselhoDeliberativo[] = [
        { tipo: 'pdf', descricao: 'extrato_ata _conse_605 _27.11.2020', caminho: '', ano: 2020 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse607_29.1.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse608_26.2.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse609_26.3.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse610_ 23.3.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse611_26.4.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse612_28.5.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse613_25.6.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse614_26.7.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse615_27.8.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse616_30.9.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse617_29.10.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse618_26.11.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse619_17.12.2021', caminho: '', ano: 2021 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse620 _24.1.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'ExtratoAtaConse621_25.2.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse622 _25.3.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse623 _25.3.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse624 _25.4.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse625 _27.5.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse626 _24.6.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse627 _25.7.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse628 _26.8.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse629 _30.9.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse630 _28.10.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse631 _25.11.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse632 _16.12.2022', caminho: '', ano: 2022 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse633 _23.1.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse634 _24.2.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse635 _6 e 7.3.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse636 _24.3.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse637 _24.3.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse638 _24.4.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse639 _24.4.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse640 _26.5.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse641 _30.6.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse642 _24.7.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse643 _25.8.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse644 _29.9.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse645 _23.10.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse646 _24.11.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse647 _15.12.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse648 _15.12.2023', caminho: '', ano: 2023 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse649 _26.1.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse650 _23.2.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse651 _26.3.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse652 _26.3.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse653 _26.4.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse654 _14.5.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse655 _14.5.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse656 _27.5.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse657 _27.5.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse658 _28.6.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse659 _26.7.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse660 _26.7.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse661 _29.8.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse662 _27.9.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse663 _25.10.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse664 _28.11.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse665 _13.12.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse666 _19.12.2024', caminho: '', ano: 2024 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse667 _13.1.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse668 _31.1.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse669 _20.2.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse670 _27.2.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse671 _27.2.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse672 _17.3.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse673 _28.3.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse674 _28.3.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse675 _25.4.2025', caminho: '', ano: 2025 },
        { tipo: 'pdf', descricao: 'Extrato_Ata_Conse676 _30.5.2025', caminho: '', ano: 2025 },
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string,
        public ano: number
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/extrato-atas-conselho-deliberativo.ts